import { select, put, call } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";

import { selectAuthAccountId } from "../../selectors/auth";
import {
  fetchBrandByPromptsSeriesFailure,
  fetchBrandByPromptsSeriesSuccess,
  setDailyAveragePromptRangeValues,
} from "../slice";
import { scoresApi } from "../../../api/scores.api";
import { reducePromptScoreDailyRowsToSeries } from "../utils/promptScoreDailyFromRows";
import { applySagaError } from "../../utils/saga";
import type { FetchBrandByPromptsSeriesPayload } from "../payload.types";
import type { ScoreDailyAverageResponse } from "../response.types";

export function* fetchBrandByPromptsSeriesSaga(action: PayloadAction<FetchBrandByPromptsSeriesPayload>) {
  try {
    const brandId = action.payload.brand_id;
    const days = action.payload.days;

    const userID: string | null = yield select(selectAuthAccountId);
    if (userID == null) {
      yield put(fetchBrandByPromptsSeriesFailure());
      return;
    }

    const rows: ScoreDailyAverageResponse[] = yield call(scoresApi.fetchBrandScoreByPromptDays, {
      userID,
      brandId,
      days,
    });

    const { scoresByPrompt, rangeValues } = reducePromptScoreDailyRowsToSeries(rows);

    yield put(setDailyAveragePromptRangeValues(rangeValues));
    yield put(fetchBrandByPromptsSeriesSuccess(scoresByPrompt));
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "scores.fetchBrandByPromptsSeries",
      failureAction: fetchBrandByPromptsSeriesFailure,
    });
  }
}
